var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTroubleshoot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.137,
    height: 25.138,
    viewBox: "0 0 25.137 25.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.998 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.513,7.565l3.449,3.449L12,9.972,8.554,6.523V3.756L3.355.008,1,2.365l3.748,5.2Z",
    transform: "translate(0 -0.007)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.593,1.293a4.531,4.531,0,0,0-.882,5.048L7.34,16.714a4.516,4.516,0,0,0-5.048.881,4.429,4.429,0,0,0-.864,5.03l2.947-2.947,2.083,2.083L3.512,24.708a4.419,4.419,0,0,0,5.029-.864A4.528,4.528,0,0,0,9.423,18.8L19.794,8.424a4.526,4.526,0,0,0,5.048-.882,4.425,4.425,0,0,0,.864-5.029L22.759,5.459,20.676,3.376,23.623.429A4.427,4.427,0,0,0,18.593,1.293Z",
    transform: "translate(-0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M266.962,269.1l3.122-3.122,1.046,1.046-3.123,3.122Z",
    transform: "translate(-252.88 -252.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M316.319,318.459l-6.839-6.839L312.6,308.5l6.839,6.839Z",
    transform: "translate(-293.306 -293.321)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubleshoot);
export default __webpack_public_path__ + "static/media/troubleshoot.7057b790.svg";
export { ForwardRef as ReactComponent };